import { render, staticRenderFns } from "./v2Class.vue?vue&type=template&id=126dd618&scoped=true&"
import script from "./v2Class.vue?vue&type=script&lang=js&"
export * from "./v2Class.vue?vue&type=script&lang=js&"
import style0 from "./v2Class.vue?vue&type=style&index=0&id=126dd618&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126dd618",
  null
  
)

export default component.exports